import { FunctionComponent, memo } from 'react';
import { Story } from '../../../services';
import { getCssVar } from '../../utils';
import { BackButton } from '../BackButton';
import { StoryFollowControls } from './StoryFollowControls';

import classes from './StoryFeedItemsHeader.module.scss';

interface StoryFeedItemsHeaderProps {
  story: Story;
}

export const StoryFeedItemsHeader: FunctionComponent<StoryFeedItemsHeaderProps> = memo(
  ({ story }) => {
    const { title, subtitle, image } = story;

    const { url: imageUrl } = { ...image };

    return (
      <>
        <BackButton color={getCssVar('--story-feed-back-color')} />

        <div className={classes['story-feed-header__details']}>
          {imageUrl && (
            <img className={classes['story-feed-header__image']} src={imageUrl} alt={''} />
          )}
          <div className={classes['story-feed-header__overlay']}>
            <div className={classes['story-feed-header__overlay-text']}>
              <h1 className={classes['story-feed-header__overlay-title']}>{title}</h1>
              {subtitle && (
                <div className={classes['story-feed-header__overlay-sub-title']}>{subtitle}</div>
              )}
            </div>
            <div className={classes['story-feed-header__overlay-controls']}>
              <StoryFollowControls story={story} />
            </div>
          </div>
        </div>
      </>
    );
  }
);
